/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const MessageSquareCheck = createLucideIcon("message-square-check", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "m0kn7k"
    }
  ],
  ["path", { d: "m9 11 2 2 4-4", key: "kz4plv" }]
]);

export { MessageSquareCheck as default };
//# sourceMappingURL=message-square-check.js.map
